/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import * as types from '../types';
import openNotification from '../../utils/openNotification';
import failureNotification from '../../utils/failureNotification';

export const editProfile = (value, id) => async dispatch => {
  dispatch({
    type: types.EDIT_PROFILE_PICTURE,
  });
  try {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/users/${id}`,
      value
    );
    dispatch({
      type: types.EDIT_PROFILE_PICTURE_SUCCESS,
      payload: data[0],
    });
    openNotification('Profile Updated Succesfully');
  } catch (error) {
    dispatch({
      type: types.EDIT_PROFILE_PICTURE_FAILURE,
      payload: error.message,
    });
    failureNotification('Profile could not be updated');
  }
};

export const EditAllUserProfile = (value, id) => async dispatch => {
  try {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/users/${id}`,
      value
    );
    await dispatch({ type: types.ISCLOSE_CHANGE });
    dispatch({
      type: types.EDIT_ALL_USER_PROFILE,
      payload: data,
    });
    window.location.reload();
  } catch (error) {
    console.log(error);
  }
};
